import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: "https://api.mercadolibre.com" });

export interface Category {
  id: string;
  name: string;
}

interface ChildrenCategory extends Category {
  total_items_in_this_category: number;
}

interface CategoryTree {
  id: string;
  name: string;
  picture?: string | null;
  permalink?: string | null;
  total_items_in_this_category: number;
  path_from_root: Category[];
  children_categories: ChildrenCategory[];
  attribute_types: string;
  settings: {
    adult_content: boolean;
    buying_allowed: boolean;
    buying_modes: string[];
    catalog_domain: string;
    coverage_areas: string;
    currencies: string[];
    fragile: boolean;
    immediate_payment: string;
    item_conditions: string[];
    items_reviews_allowed: boolean;
    listing_allowed: boolean;
    max_description_length: number;
    max_pictures_per_item: number;
    max_pictures_per_item_var: number;
    max_sub_title_length: number;
    max_title_length: number;
    maximum_price?: number | null;
    minimum_price: number;
    mirror_category?: any | null;
    mirror_master_category?: any | null;
    mirror_slave_categories: any[];
    price: string;
    reservation_allowed: string;
    restrictions: any[];
    rounded_address: boolean;
    seller_contact: string;
    shipping_modes: string[];
    shipping_options: string[];
    shipping_profile: string;
    show_contact_information: boolean;
    simple_shipping: string;
    stock: string;
    sub_vertical?: any | null;
    subscribable: boolean;
    tags: any[];
    vertical?: any | null;
    vip_subdomain: string;
    buyer_protection_programs: string[];
    status: string;
  };
  meta_categ_id?: any | null;
  attributable: boolean;
  date_created: string;
}

type CategoriesTreeResponse = Record<string, CategoryTree>;

export const getCategory = async (categoryId: string, token: string | null) => {
  try {
    const response = await axios.get(
      Constants.BASE_URL + `/meli/token?categoryId=${categoryId}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
